import { UserAccessRestrictionCode } from "~/domain/user-session/types"

export class AccessError extends Error {
	constructor(public readonly code: UserAccessRestrictionCode, public readonly errorMessage?: string | React.ReactElement<any, string | React.JSXElementConstructor<any>>) {
		super()
	}
}